import { ApprovalsQueuePage } from '@/components/approvals/approvals-queue-page'

export function CommitteeApprovals() {
  return <ApprovalsQueuePage />
}
